
import React from 'react';

const FilterInformationSection = () => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.target as HTMLImageElement;
    target.src = '/lovable-uploads/90959052-01e0-4de5-a75c-812d72605f31.png';
    console.log('Filter information image failed to load, using fallback');
  };

  return (
    <section className="section-padding bg-autocare-gray-light">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-semibold text-autocare-blue bg-autocare-blue/10 rounded-full mb-4">
              Filter Guide
            </span>
            <h2 className="text-3xl font-bold text-autocare-blue mb-4">Understanding Vehicle Filters</h2>
            <p className="text-gray-600 mb-6">
              Your vehicle's filters are essential for maintaining engine health and performance. Here's what you need to know about different filter types.
            </p>
            
            <div className="space-y-6">
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h3 className="font-semibold text-lg mb-2">Air Filter</h3>
                <p className="text-gray-600 text-sm">
                  Prevents dust, debris, and contaminants from entering your engine, ensuring clean air intake for optimal combustion.
                </p>
              </div>
              
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h3 className="font-semibold text-lg mb-2">Oil Filter</h3>
                <p className="text-gray-600 text-sm">
                  Removes contaminants from your engine oil, protecting vital engine components from wear and damage.
                </p>
              </div>
              
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h3 className="font-semibold text-lg mb-2">Fuel Filter</h3>
                <p className="text-gray-600 text-sm">
                  Keeps your fuel system clean by removing impurities that could harm your engine's fuel injection system.
                </p>
              </div>
              
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h3 className="font-semibold text-lg mb-2">Cabin Air Filter</h3>
                <p className="text-gray-600 text-sm">
                  Ensures clean air inside your vehicle by filtering out dust, pollen, and other airborne particles.
                </p>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="/lovable-uploads/90959052-01e0-4de5-a75c-812d72605f31.png"
              alt="Different types of vehicle filters" 
              className="rounded-xl shadow-lg"
              onError={handleImageError}
            />
            
            <div className="absolute -bottom-6 -right-6 bg-autocare-yellow p-4 rounded-lg shadow-lg">
              <div className="text-autocare-blue text-center">
                <div className="text-xl font-bold">10,000+</div>
                <div className="text-sm">Filter Changes</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FilterInformationSection;
